<template>
  <div>
    <PageTitle
      v-if="StockTransfer.status == 'Pending'"
      title="Stock Transfer View"
      :backBtn="true"
      :editRoute="'/stock-transfer/' + 'edit/' + $route.params.id"
      :permission="'Purchase Order Edit'"
      @onClickChangeStatus="onClickChangeStatus"
      :changeStatus="true"
    />
    <PageTitle
      v-if="StockTransfer.status != 'Pending'"
      title="Stock Transfer View"
      :backBtn="true"
    />
    <v-row class="mx-2">
      <v-col cols="12" sm="12" md="12" lg="12">
        <v-row>
          <v-col cols="12" sm="12" md="12" lg="12">
            <v-card class="lighten-12">
              <v-card-title class="py-0">
                <v-icon color="blue" small>mdi-sale</v-icon
                ><span class="ml-3"> Purchase Details</span>
              </v-card-title>
              <v-container fluid class="container saledetailscard">
                <v-row>
                  <v-col cols="12" sm="12" md="12" lg="12" class="pt-0">
                    <v-row class="pt-0">
                      <v-col
                        cols="12"
                        sm="12"
                        md="4"
                        lg="4"
                        class="pr-5pt-1.5 pb-1 reference_number"
                      >
                        <v-icon>mdi-sale</v-icon>
                        {{
                          StockTransfer.reference_number
                            ? StockTransfer.reference_number
                            : '----'
                        }}
                      </v-col>

                      <v-col cols="12" sm="12" md="4" lg="4">
                        <span class="statustext pr-5">Status</span>
                        <v-chip
                          label
                          text-color="white"
                          style="
                            font-variant-caps: all-small-caps;
                            font-weight: bold;
                          "
                          :color="
                            getPurchaseOrderStatusColor(
                              StockTransfer.statusChange,
                            )
                          "
                          dark
                        >
                          {{
                            StockTransfer.statusChange
                              ? StockTransfer.statusChange
                              : '----'
                          }}
                        </v-chip>
                      </v-col>

                      <v-col cols="12" sm="12" md="4" lg="4">
                        <span class="statustext pr-5">Status Note</span>

                        {{
                          StockTransfer.statusNoteChange
                            ? StockTransfer.statusNoteChange
                            : '----'
                        }}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="4"
                        lg="4"
                        class="shoptext pr-5 pt-0 mt-5"
                      >
                        <v-row class="subtextlable"> Transfer Date </v-row>
                        <v-row>
                          {{ StockTransfer.date | formatDate }}
                        </v-row>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="1"
                        lg="1"
                        class="shoptext pr-5 pt-0 mt-7"
                      >
                        <v-divider></v-divider>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="3"
                        lg="3"
                        class="shoptext pr-5 pt-0 mt-5"
                      >
                        <v-row class="subtextlable"> Warehouse from </v-row>
                        <v-row>
                          {{
                            StockTransfer.warehouse.name
                              ? StockTransfer.warehouse.name
                              : '----'
                          }}
                        </v-row>
                      </v-col>

                      <v-col
                        cols="1"
                        sm="12"
                        md="1"
                        lg="1"
                        class="shoptext pr-5 pt-0 mt-7"
                      >
                        <v-divider></v-divider>
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="3"
                        lg="3"
                        class="shoptext pr-5 pt-0 mt-5"
                      >
                        <v-row class="subtextlable">Transfer To Shop </v-row>
                        <v-row>
                          <v-icon small>mdi-calendar</v-icon>
                          {{
                            StockTransfer.shop.name
                              ? StockTransfer.shop.name
                              : '----'
                          }}

                          <v-menu
                            offset-y
                            v-if="StockTransfer.status == 'Pending'"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                large
                                color="primary darken-2"
                                v-bind="attrs"
                                v-on="on"
                                class="ma-1 white ml-2"
                                @click="changeShop()"
                              >
                                mdi-pencil
                              </v-icon>
                            </template>
                          </v-menu>

                          <v-row v-if="isTrue">
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              class="text-right"
                            >
                              <ValidationProvider name="Shop" rules="required">
                                <v-autocomplete
                                  outlined
                                  hide-details="auto"
                                  v-model="StockTransfer.to_shop_id"
                                  item-text="name"
                                  item-value="id"
                                  :items="shops"
                                  :search-input.sync="searchShop"
                                  :loading="shopLoading"
                                  :error-messages="errors"
                                  label="Shop"
                                  required
                                ></v-autocomplete>
                              </ValidationProvider>
                            </v-col>
                            <v-col
                              cols="6"
                              sm="6"
                              md="6"
                              lg="6"
                              class="text-left"
                              v-if="isTrue"
                            >
                              <v-btn
                                color="green"
                                x-small
                                dark
                                :disabled="isDisabledShop"
                                @click="openConfirmation()"
                              >
                                <v-icon link>done</v-icon>
                              </v-btn>
                              <v-btn
                                color="secondary"
                                x-small
                                dark
                                class="ma-1"
                                @click="cancelShopUpdate()"
                              >
                                <v-icon
                                  depressed
                                  small
                                  link
                                  @click="cancelShopUpdate()"
                                  >clear</v-icon
                                >
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-container>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <v-row class="mx-2">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12" class="py-0">
        <v-card class="lighten-12 container pa-0">
          <v-card-title class="d-flex justify-space-between v-card__title py-0"
            >Transfered Product details
            <!-- <v-btn small class="text-white btn_gray w-100" v-print="printQr"
              >Print <v-icon right dark> mdi-printer </v-icon></v-btn
              > -->
          </v-card-title>
          <v-container fluid class="container saledetailscard">
            <v-row>
              <v-col cols="12" class="pa-0">
                <v-data-table
                  class="std-100 ma-0 pa-0"
                  items-per-page="15"
                  :fixed-header="true"
                  :headers="StockTransferHeaders"
                  @click:row="ExpandItem($event)"
                  :items="selectedProductsToTransfer"
                  :single-expand="singleExpand"
                  :expanded.sync="expanded"
                  hide-default-footer
                  dense
                  expand
                >
                  <template
                    v-slot:item.data-table-expand="{ item, isExpanded, expand }"
                  >
                    <span
                      @click="ExpandItem($event)"
                      class="mdi mdi-chevron-double-down"
                    ></span>
                    <span
                      @click="ExpandItem($event)"
                      v-if="expanded.length > 0 && item.id == expanded[0].id"
                      class="mdi mdi-chevron-double-up"
                    ></span>
                  </template>
                  <template v-slot:expanded-item="{ headers, item: childItem }">
                    <td :colspan="headers.length">
                      <v-card class="pa-0">
                        <v-data-table
                          dense
                          hide-default-footer
                          :items="unitDetails"
                          :headers="TransferItemUnitHeaders"
                          class="sub-table pb-1 mx-0"
                        >
                          <v-progress-linear
                            v-show="progressBar"
                            slot="progress"
                            color="blue"
                            indeterminate
                          ></v-progress-linear>
                        </v-data-table>
                      </v-card>
                    </td>
                  </template>
                  <!-- Category -->
                  <template v-slot:item.category="{ item }">
                    {{
                      item.productCategory.name
                        ? item.productCategory.name
                        : '----'
                    }}
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" sm="12" md="12" lg="12">
        <!-- <v-card>
            <v-card-title>Note</v-card-title>

            <v-container fluid>
              <v-row>
                <v-col cols="12" sm="12" md="12" lg="12"
                  ><v-chip class="pa-0" label>
                    {{ StockTransfer.remarks ? StockTransfer.remarks : "----" }}
                  </v-chip>
                </v-col>
              </v-row>
            </v-container>
          </v-card> -->
      </v-col>
    </v-row>
    <change-status
      :statusNote="StockTransfer.status_note"
      :visible="visibleChangeStatusModal"
      :statuses="transferStatuses"
      :selectedStatus="StockTransfer.status"
      @onChangeStatus="onChangeStatus"
      @close="onCloseChangeStatus"
    ></change-status>
  </div>
</template>

<script>
import ChangeStatus from '@/components/shared/ChangeStatus';
import FileUpload from '@/components/base/FileUpload';
import jsPDF from 'jspdf';
import VueDocPreview from 'vue-doc-preview';
import 'jspdf-autotable';
import { PurchaseOrderViewModel } from '../../../models/View Models/PurchaseOrderViewModel';
import { StockTransferModel } from '@/models/StockTransferModel';
import confirmation from '@/modules/shared/components/confirmation';
import { mapState } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';

export default {
  data: () => ({
    changeStatusVisible: true,
    expanded: [],
    isTrue: false,
    isDisabledShop: false,
    PurchaseOrder: [],
    productUnits: [],
    singleExpand: true,
    StatusReasonErrorMessages: [],
    shopId: '',
    shopName: '',
    shops: [],
    StockTransferStatus: ['Completed', 'Canceled', 'Pending'],
    selectedProductsToTransfer: [],
    StockTransfer: new StockTransferModel(),
    shopLoading: false,
    searchShop: null,
    transferStatuses: [
      { requiredNote: false, status: 'Completed' },
      { requiredNote: false, status: 'Pending' },
      { requiredNote: false, status: 'Canceled' },
    ],
    visibleChangeStatusModal: false,
    unitDetails: [],
    heading: 'Sample PDF Generator',
    moreText: [
      'This is another few sentences of text to look at it.',
      'Just testing the paragraphs to see how they format.',
      'jsPDF likes arrays for sentences.',
      'Do paragraphs wrap properly?',
      'Yes, they do!',
      'What does it look like?',
      'Not bad at all.',
    ],

    selectedProductsItems: [],

    StockTransferHeaders: [
      { text: 'Product', value: 'product.name', sortable: false },
      { text: 'Batch', value: 'batch.batch', sortable: false },
      { text: 'Quantity', value: 'quantity', sortable: false },
      { text: 'Waste Percentage', value: 'wastePercentage', sortable: false },
      { text: 'Return Quantity', value: 'return_quantity', sortable: false },
      { text: 'Unit', value: 'unit.name', sortable: false, align: 'center' },
    ],
    TransferItemUnitHeaders: [
      { text: 'Unit', value: 'name', sortable: false },
      { text: 'Tranferable Percentage', value: 'percentage', sortable: false },
      { text: 'Quantity', value: 'quantity', sortable: false },
    ],
  }),
  methods: {
    onChangeStatus(value) {
      value.id = this.$route.params.id;
      this.$store
        .dispatch('stock/ChangeStatus', value)
        .then((res) => {
          this.changeStatusVisible = false;

          this.getStockTransfer();
          this.visibleChangeStatusModal = false;
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    changeShop() {
      this.isTrue = true;
    },
    cancelShopUpdate() {
      this.isTrue = false;
    },
    onClickChangeStatus(value) {
      this.visibleChangeStatusModal = true;
    },
    onCloseChangeStatus() {
      this.visibleChangeStatusModal = false;
    },
    getPurchaseOrderStatusColor(status) {
      switch (status) {
        case 'Completed':
          return 'green';
          break;
        case 'Pending':
          return 'orange';
          break;
        case 'Canceled':
          return 'red';
          break;

        default:
          break;
      }
    },
    print() {
      this.$htmlToPaper('qr-code');
    },
    getStockTransfer() {
      this.Loading = true;
      this.$store
        .dispatch('product/GetTranferDetails', this.$route.params.id)
        .then((res) => {
          this.MapStoreTranfer(res);
        })
        .catch((err) => {
          this.warehouseLoading = false;
          this.messages = err.data.name;
        });
    },
    // Shop Update Function
    async submit() {
      if (this.selectedProductsToTransfer.length != 0) {
        this.StockTransfer.items = this.selectedProductsToTransfer;

        let Credentials = new Object();
        Credentials.date = this.StockTransfer.date;
        Credentials.remarks = this.StockTransfer.remarks;
        Credentials.from_ware_house_id = this.StockTransfer.from_ware_house_id;

        Credentials.to_shop_id = this.StockTransfer.to_shop_id;
        Credentials.items = [];
        let error = false;
        this.StockTransfer.items.map((p) => {
          let item = new Object();
          item.product_id = p.product.id;
          item.batch_id = p.batch.id;
          item.unit_id = p.unit.id;
          item.quantity = p.quantity;
          item.return_quantity = 0;
          item.wast_percentage = 0;
          item.transferUnit = [];
          p.productUnits.map((u) => {
            let pUnit = new Object();
            if (p.maxReturnError.length > 0) {
              error = true;
            }
            pUnit.unit_id = u.id;
            pUnit.quantity = u.quantity ? u.quantity : 0;
            (pUnit.transferable_percentage = u.percentage),
              (pUnit.is_changes_unit = u.is_changes_unit);
            if (u.is_changes_unit && u.quantity > 0 && u.percentage > 0) {
              item.transferUnit.push(pUnit);
            }
          });
          if (item.transferUnit.length > 0) Credentials.items.push(item);
        });
        if (Credentials.items.length > 0 && !error) {
          Credentials.id = this.$route.params.id;
          this.$store
            .dispatch(
              'product/TranferProductToShopFromWarehouseEdit',
              Credentials,
            )
            .then((res) => {
              this.$toast.success('Product Transfered Successfully');
              this.$router.push('/stock-transfer');
            })
            .catch((err) => {});
        } else {
          this.isProductListValid = 'quantity of items to transfer is zero';
        }
      }
    },

    GetWastePercentage(product) {
      let productSelected = this.selectedProductsToTransfer.find(
        (p) => p.unitqId == product.unitqId,
      );
      let TotalPecentage = 0;
      if (productSelected) {
        productSelected.productUnits.map((p) => {
          if (parseInt(p.transferPecentage) > 0) {
            TotalPecentage = parseInt(p.transferPecentage) + TotalPecentage;
          }
        });
      }
      if (product.returnQuantity > 0) {
        // let totalQuantity=(parseInt(product.quantity)*(parseInt(TotalPecentage)/100))+parseInt(product.returnQuantity)
        TotalPecentage =
          TotalPecentage + (product.returnQuantity / product.quantity) * 100;
      }
      return (100 - TotalPecentage).toFixed(2);
    },

    UpdateStatus() {
      if (
        this.StockTransfer.statusChange == 'Canceled' &&
        this.StockTransfer.statusNoteChange == null
      ) {
        this.StatusReasonErrorMessages.push('Reason is Required');
      } else {
        this.StatusReasonErrorMessages = [];
        confirmation.dialog = true;
        this.$confirm(
          `Do you want to ${this.StockTransfer.statusChange} Transfer`,
        ).then((res) => {
          if (res) {
            this.$store
              .dispatch(`stock/UpdateTransferStatus`, {
                stockId: this.$route.params.id,
                data: {
                  status: this.StockTransfer.statusChange,
                  status_note: this.StockTransfer.statusNoteChange,
                },
              })
              .then((res) => {
                this.getStockTransfer();
                this.$toast.success('Status updated successfully');
              })
              .catch((err) => {
                this.isLoading = false;
                this.$toast.error('Failed to update status');
                this.show = false;
              });
          } else {
            this.Purchase.isUpdate = !this.Purchase.isUpdate;
          }
        });
      }
    },
    // shop update button function
    openConfirmation() {
      confirmation.dialog = true;
      this.$confirm('Are you sure with the update ').then((res) => {
        if (res) {
          this.submit();
        }
      });
    },

    changeStatus() {
      this.StockTransfer.isUpdate = !this.StockTransfer.isUpdate;
      if (!this.StockTransfer.isUpdate) {
        this.StockTransfer.isUpdate = true;
        this.UpdateStatus();
      }
    },
    getShopsByQuery(query = '') {
      this.shopLoading = true;
      this.$store
        .dispatch('warehouse/GetShops', { query: query })
        .then((res) => {
          this.shops = res;
          this.shopLoading = false;
        })
        .catch((err) => {
          this.shopLoading = false;
          this.messages = err.data.name;
        });
    },
    ExpandItem(event) {
      this.progressBar = true;
      this.unitDetails = event.transferUnit;
      this.expanded = [];
      this.progressBar = false;
      this.expanded.push(event);
    },

    MapStoreTranfer(stockTransferDetails) {
      let count = 1;
      var StockTransfer = new Object();
      StockTransfer.date = stockTransferDetails.date;
      StockTransfer.reference_number = stockTransferDetails.reference_number;
      this.searchShop = stockTransferDetails.shop.name;
      StockTransfer.remarks = stockTransferDetails.remarks;
      StockTransfer.status = stockTransferDetails.status;
      StockTransfer.statusChange = stockTransferDetails.status;
      StockTransfer.statusNote = stockTransferDetails.status_note;
      StockTransfer.statusNoteChange = stockTransferDetails.status_note;
      StockTransfer.isUpdate = false;

      StockTransfer.from_ware_house_id =
        stockTransferDetails.from_ware_house_id;
      StockTransfer.warehouse = stockTransferDetails.wareHouse;
      StockTransfer.to_shop_id = stockTransferDetails.to_shop_id;
      StockTransfer.shop = stockTransferDetails.shop;
      stockTransferDetails.transferItems.map((p) => {
        let item = new Object();
        item.product = p.product;
        item.batch = p.batch;
        item.id = count;
        item.unit = p.unit;
        item.quantity = p.quantity;
        item.transferUnit = [];
        count++;
        item.wastePercentage = p.wast_percentage;
        item.return_quantity = p.return_quantity;
        item.productUnits = [];
        item.maxReturnError = [];
        p.transferItemUnits.map((u) => {
          let pUnit = new Object();
          pUnit.name = u.unit.name;
          pUnit.id = u.unit.id;
          pUnit.quantity = u.quantity ? u.quantity : 0;
          (pUnit.percentage = u.transferable_percentage
            ? parseInt(u.transferable_percentage)
            : 0),
            (pUnit.is_changes_unit = u.is_changes_unit);
          item.transferUnit.push(pUnit);
          item.productUnits.push(pUnit);
          return pUnit;
        });
        let val = this.selectedProductsToTransfer.filter(
          (i) => item.id == i.id,
        );
        if (val.length == 0) {
          this.selectedProductsToTransfer.push(item);
        }

        count++;
        return item;
      });
      this.StockTransfer = StockTransfer;
    },
  },
  components: {
    FileUpload,
    VueDocPreview,
    ChangeStatus,
  },
  computed: {
    printQr() {
      return {
        id: 'qr-code',
        popTitle: this.PurchaseOrder.name,
      };
    },
    ...mapState(['productpagesize']),
  },
  created() {
    this.getStockTransfer();
    this.getShopsByQuery();
  },
  watch: {
    searchShop(value) {
      if (!value) {
        this.getShopsByQuery('');
      }
      this.getShopsByQuery(value);
    },
  },
};
</script>

<style>
.std-100 {
  font-weight: bold;
}
.std-101 {
  font-weight: 900;
}

.rowspce {
  margin-bottom: -100px;
}

.cntclr {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
  margin-bottom: -16px;
}

.container1 {
  margin-right: 24px;
  margin-left: 20px;
}
.purchaseDetail {
  font-weight: bold;
}
.subtextlable {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 9px;
  line-height: 11px;
  /* identical to box height */

  text-align: left;

  color: #928686;
}
.shoptext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 14px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.statustext {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 12px;
  /* identical to box height */

  text-align: center;

  color: #045894;
}
.v-card__title {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  font-size: 1.25rem;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2rem;
  word-break: break-all;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  background-color: white;
}
.saledetailscard {
  background: #fffefe;
  box-sizing: border-box;
  border: 1px solid #afa9a9;
  box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.25);
}
.reference_number {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  /* identical to box height */

  text-align: center;

  color: #000000;
}
.saletiltle {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 16px;
}
</style>
